import React from "react";

import "./Feature.scss";
import featureImage from "../../assets/feature/1st.jpg";
import second from "../../assets/feature/2nd.jpg";
import third from "../../assets/feature/3rd.jpg";
import fourth from "../../assets/feature/4th.jpg";
import fifth from "../../assets/feature/5th.jpg";

import bamboo2 from "../../assets/bamboo/2.jpg";
import bamboo22 from "../../assets/bamboo/22.jpg";
import bamboo23 from "../../assets/bamboo/23.jpg";
import bamboo24 from "../../assets/bamboo/24.jpg";
import bamboo28 from "../../assets/bamboo/28.jpg";

import h2bh5 from "../../assets/h2bh/5-H2BH.jpg";
import h2bh6 from "../../assets/h2bh/6-H2BH.jpg";
import h2bh19 from "../../assets/h2bh/19-H2BH.jpg";
import h2bh32 from "../../assets/h2bh/32-H2BH.jpg";
import h2bh33 from "../../assets/h2bh/33-H2BH.jpg";

const k2m2 = "https://firebasestorage.googleapis.com/v0/b/jocelyns-portfolio.appspot.com/o/KNOW2MANY%2FV6.00_00_51_10.Still009.png?alt=media"
const k2m3 = "https://firebasestorage.googleapis.com/v0/b/jocelyns-portfolio.appspot.com/o/KNOW2MANY%2FV6.00_01_36_17.Still011.png?alt=media"
const k2m4 = "https://firebasestorage.googleapis.com/v0/b/jocelyns-portfolio.appspot.com/o/KNOW2MANY%2FV6.00_01_46_04.Still010.png?alt=media"
const k2m5 = "https://firebasestorage.googleapis.com/v0/b/jocelyns-portfolio.appspot.com/o/KNOW2MANY%2FV6.00_02_15_07.Still013.png?alt=media"
const k2m6 = "https://firebasestorage.googleapis.com/v0/b/jocelyns-portfolio.appspot.com/o/KNOW2MANY%2FV6.00_02_54_14.Still016.png?alt=media"

const motha = "https://firebasestorage.googleapis.com/v0/b/jocelyns-portfolio.appspot.com/o/BREATHE%20MOTHA%2FBreath%20Motha_FINAL.00_00_23_20.Still001.jpg?alt=media"
const motha2 = "https://firebasestorage.googleapis.com/v0/b/jocelyns-portfolio.appspot.com/o/BREATHE%20MOTHA%2FBreath%20Motha_FINAL.00_01_11_14.Still003.jpg?alt=media"
const motha3 = "https://firebasestorage.googleapis.com/v0/b/jocelyns-portfolio.appspot.com/o/BREATHE%20MOTHA%2FBreath%20Motha_FINAL.00_01_13_07.Still002.jpg?alt=media"
const motha4 = "https://firebasestorage.googleapis.com/v0/b/jocelyns-portfolio.appspot.com/o/BREATHE%20MOTHA%2FBreath%20Motha_FINAL.00_02_10_10.Still005.jpg?alt=media"
const motha5 = "https://firebasestorage.googleapis.com/v0/b/jocelyns-portfolio.appspot.com/o/BREATHE%20MOTHA%2FBreath%20Motha_FINAL.00_02_22_12.Still006.jpg?alt=media"

const prettyPictures = "https://firebasestorage.googleapis.com/v0/b/jocelyns-portfolio.appspot.com/o/PRETTY%20PICTURES%2FFINAL%20FINAL%20FR%20FR%20.00_02_26_10.Still004.jpg?alt=media&token=89546d62-7325-41cc-b630-8777d83e9542"
const prettyPictures2 = "https://firebasestorage.googleapis.com/v0/b/jocelyns-portfolio.appspot.com/o/PRETTY%20PICTURES%2FFINAL%20FINAL%20FR%20FR%20.00_02_30_18.Still005.jpg?alt=media&token=61f9b485-72ac-4a51-b9d3-a58227598e7f"
const prettyPictures3 = "https://firebasestorage.googleapis.com/v0/b/jocelyns-portfolio.appspot.com/o/PRETTY%20PICTURES%2FFINAL%20FINAL%20FR%20FR%20.00_00_11_05.Still006.jpg?alt=media&token=a4239f52-dcf6-4694-92e5-4a62f3eef990"
const prettyPictures4 = "https://firebasestorage.googleapis.com/v0/b/jocelyns-portfolio.appspot.com/o/PRETTY%20PICTURES%2FFINAL%20FINAL%20FR%20FR%20.00_02_18_10.Still003.jpg?alt=media&token=19bfbd46-d716-478a-96d5-9294cdda8446"

const ar1 = "https://firebasestorage.googleapis.com/v0/b/jocelyns-portfolio.appspot.com/o/AR115%2FAR-115%20-%20frame%20at%200m21s.jpg?alt=media"
const ar2 = "https://firebasestorage.googleapis.com/v0/b/jocelyns-portfolio.appspot.com/o/AR115%2FAR-115%20-%20frame%20at%2011m34s.jpg?alt=media"
const ar3 = "https://firebasestorage.googleapis.com/v0/b/jocelyns-portfolio.appspot.com/o/AR115%2FAR-115%20-%20frame%20at%201m6s.jpg?alt=media"
const ar4 = "https://firebasestorage.googleapis.com/v0/b/jocelyns-portfolio.appspot.com/o/AR115%2FAR-115%20-%20frame%20at%203m3s1.jpg?alt=media"
const ar5 = "https://firebasestorage.googleapis.com/v0/b/jocelyns-portfolio.appspot.com/o/AR115%2FAR-115%20-%20frame%20at%207m17s.jpg?alt=media"
const ar6 = "https://firebasestorage.googleapis.com/v0/b/jocelyns-portfolio.appspot.com/o/AR115%2FStereo.00_01_41_02.Still007.jpg?alt=media"
const ar7 = "https://firebasestorage.googleapis.com/v0/b/jocelyns-portfolio.appspot.com/o/AR115%2FAR-115%20-%20frame%20at%2010m50s.jpg?alt=media"
const ar8 = "https://firebasestorage.googleapis.com/v0/b/jocelyns-portfolio.appspot.com/o/AR115%2FAR-115%20-%20frame%20at%208m43s.jpg?alt=media"

const images = {
  cork: [featureImage, second, third, fourth, fifth],
  bamboo: [bamboo2, bamboo22, bamboo23, bamboo24, bamboo28],
  happy: [h2bh5, h2bh6, h2bh19, h2bh32, h2bh33],
  k2m: [ k2m2, k2m3, k2m4, k2m5, k2m6],
  motha: [motha, motha2, motha3, motha4, motha5],
  prettyPictures: [prettyPictures, prettyPictures2, prettyPictures3, prettyPictures4],
  ar115: [ar1, ar2, ar3, ar4, ar5, ar6, ar8, ar7],
};

function Image({ item, onClick }) {
  return (
    <div className="list-image-container">
      <img
        className={"list-image"}
        src={item.thumbnail}
        alt="Italian Trulli"
        onClick={onClick}
      />
    </div>
  );
}

function Feature({ name }) {
  return (
    <div className="feature-container">
      <div className="list-image-grid">
        {name in images && images[name].map((img, i) => (
          <Image key={i} item={{ thumbnail: img }} />
        ))}
      </div>
    </div>
  );
}

export default Feature;
